export default "__VITE_ASSET__BMh8fwBn__"